import { Button, Layout, Tag } from '@loadsmart/miranda-react'
import { getToken } from '@loadsmart/miranda-react/dist/tokens'

import { formatDate, formatLocation } from 'core/presenters/stopPresenter'
import { getTruckLabel } from 'core/presenters/truckPresenter'
import { CardInfoItem } from 'core/ui/components/card/CardInfoItem'
import { VerticalDivider } from 'core/ui/components/divider/VerticalDivider'
import { ShipperInformation } from 'core/ui/components/shipper/ShipperInformation'
import { LaneInformation } from 'core/ui/components/stop/LaneInformation'

import { formatCommodities } from '../presenters/baseShipmentPresenter'
import { LastLocation } from './LastLocation'
import { type ShipmentCardProps } from './ShipmentCard'
import { ShipmentIdentifiers } from './ShipmentIdentifiers'

export function ShipmentCardDesktop({
  shipment,
  getActionLabel,
  getIdentifiers,
  getStatus,
  onActionClick,
}: ShipmentCardProps) {
  const actionLabel = getActionLabel?.()
  const identifiers = getIdentifiers?.()
  const { label, variant } = getStatus?.() ?? {}

  const { equipmentType, mileage, mode, shipper, stops } = shipment
  const commodities = formatCommodities(shipment)

  function handleOnActionClick(event: React.MouseEvent) {
    event.stopPropagation()
    onActionClick?.()
  }

  return (
    <Layout.Box
      backgroundColor="color-background-primary"
      borderRadius="border-radius-s"
      borderWidth="border-thin"
      borderColor="color-border"
      padding="none"
      style={{ display: 'block' }}
      data-testid="shipment-card-desktop"
    >
      <Layout.Group style={{ padding: getToken('spacing-6'), flexWrap: 'nowrap' }}>
        <Layout.Stack gap="spacing-6" style={{ flexGrow: 1 }}>
          <ShipmentIdentifiers identifiers={identifiers} />
          <LaneInformation
            stops={stops}
            distance={mileage}
            valueFormatter={formatLocation}
            extraFormatter={formatDate}
            distanceUnit="miles"
          />
          <Layout.Group gap="spacing-6">
            <ShipperInformation
              companyName={shipper.companyName}
              logo={shipper.logoUrl}
              showContactInfo={false}
            />
            <VerticalDivider />
            <CardInfoItem title="Mode" value={mode} />
            <VerticalDivider />
            <CardInfoItem title="Equipment" value={getTruckLabel(equipmentType)} />
            {commodities && (
              <>
                <VerticalDivider />
                <CardInfoItem title="Commodity" value={commodities} />
              </>
            )}
          </Layout.Group>
        </Layout.Stack>
        <Layout.Stack align="flex-end" justify="space-between">
          <Tag variant={variant}>{label}</Tag>
          {actionLabel && (
            <Button
              variant="secondary"
              type="button"
              onClick={handleOnActionClick}
              style={{ whiteSpace: 'nowrap' }}
            >
              {actionLabel}
            </Button>
          )}
        </Layout.Stack>
      </Layout.Group>
      <LastLocation shipment={shipment} />
    </Layout.Box>
  )
}
